"use client"

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { showToast } from "@/src/components/toast/showToast";
import { convertPersianToEnglish } from "@/src/tools";
import { useState } from "react";
import { ValidateContact } from "./tools";
import { post } from "@/src/api/apiHandler";

const FormContact = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [mobile, setMobile] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    const SubmitContact = async (e: React.FormEvent) => {
        e.preventDefault();
        const validate = ValidateContact(firstName, lastName, mobile, description);
        if (validate !== "") {
            showToast(validate, "info");
            return false;
        } else {
            try {
                setLoading(true);
                const data = await post("/form", {
                    firstName,
                    lastName,
                    mobile,
                    description,
                });
                if (data.message === "success") {
                    setFirstName("");
                    setLastName("");
                    setMobile("");
                    setDescription("");
                    showToast("با موفقیت ارسال شد", "success");
                    setLoading(false);
                } else {
                    showToast("مشکلی پیش آمده دوباره تلاش کنید", "error");
                    setLoading(false);
                }
            } catch (error) {
                showToast("مشکلی پیش آمده دوباره تلاش کنید", "error");
                setLoading(false);
            }
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value: inputValue } = e.target;
        const reg = /^[0-9\u06F0-\u06F9]+$/;
        if (reg.test(inputValue) || inputValue === "" || inputValue === "-") {
            setMobile(convertPersianToEnglish(inputValue));
        }
    };

    return (
        <form onSubmit={SubmitContact}>
            <div className="my-2 ">
                <Label htmlFor="first-name">نام</Label>
                <Input className="bg-white"
                            onChange={(e) => setFirstName(e.target.value)} value={firstName} type="text" id="first-name" placeholder="نام خود را به فارسی وارد کنید" />
            </div>
            <div className="my-2 ">
                <Label htmlFor="last-name">نام خانوادگی</Label>
                <Input className="bg-white"
                            onChange={(e) => setLastName(e.target.value)} value={lastName} type="text" id="last-name" placeholder="نام خانوادگی خود را به فارسی وارد کنید" />
            </div>
            <div className="my-2 ">
                <Label htmlFor="last-name">شماره موبایل</Label>
                <Input
className="bg-white"
            name="mobile"
                    placeholder="09123453451"
                    maxLength={11}
                    value={mobile}
                    onChange={handleChange}
                />
            </div>
            <div className="my-2 ">
                <Label htmlFor="address">توضیحات</Label>
                <Textarea  className="bg-white" rows={4} onChange={(e) => setDescription(e.target.value)} value={description} id="description" placeholder="متن خود را وارد کنید" />
            </div>
            <Button type="submit" disabled={loading}>
                ارسال
            </Button>
        </form>
    )
}

export default FormContact